import { ToastPosition, toast as reactToastify } from 'react-toastify'

const toast = (type: 'success' | 'error', message: string, autoClose = true): void => {
  const isStudioRoute = window.location.pathname.startsWith('/studio')

  if (isStudioRoute) {
    document.documentElement.style.setProperty('--toastify-z-index', '0')
  } else {
    document.documentElement.style.removeProperty('--toastify-z-index')
  }

  const commonToastOptions = {
    hideProgressBar: true,
    autoClose: autoClose ? 3000 : undefined,
    toastId: 'successdfyfdhdf',
    position: 'top-right' as ToastPosition,
    style: {
      background: '#F5FAFF',
      color: '#333333',
      border: type === 'success' ? '2px solid #5A8649' : '2px solid #CD3029',
      borderRadius: '12px',
      padding: '10px',
      boxShadow: type === 'success' ? '10px 4px #5A8649' : '10px 4px #CD3029',
      marginTop: isStudioRoute ? '40px' : '0px',
      zIndex: 1
    }
  }

  reactToastify[type](message, commonToastOptions)
}

toast.success = (message: string, autoClose = true): void => toast('success', message, autoClose)
toast.error = (message: string, autoClose = true): void => toast('error', message, autoClose)

export default toast
